import React from "react";
import { ShieldCheck, ClipboardCheck, MapPin, FileText, Repeat, ArrowRight } from "lucide-react";

export const QUALITY_STEPS = [
  { icon: Repeat, title: "Contrôles réguliers", text: "Chaque site est audité selon une fréquence définie avec vous (mensuelle par défaut) par un responsable de secteur, en plus du suivi quotidien des intervenants." },
  { icon: ClipboardCheck, title: "Grille de contrôle en 6 zones", text: "Sols, sanitaires, postes de travail, vitres, consommables et parties communes sont notés de 1 à 5 : un taux de conformité global est calculé à chaque passage." },
  { icon: MapPin, title: "Réalisé sur site, géolocalisé", text: "Le contrôle est effectué sur place, horodaté et géolocalisé, avec photos à l'appui et visa de votre référent sur place." },
  { icon: FileText, title: "Rapport et actions correctives", text: "Vous recevez un rapport PDF détaillé. Les points à corriger sont transformés en actions planifiées et suivies jusqu'à leur clôture." },
];

/* Home section: regular follow-up & quality controls. */
const QualitySection = () => (
  <section id="qualite" className="py-20 md:py-28 bg-neutral-950 text-white" data-testid="quality-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 items-start">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4 flex items-center gap-2"><ShieldCheck size={14} /> Suivi & contrôle qualité</p>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl leading-tight">Une propreté <span className="text-brand">mesurée</span>, pas seulement promise.</h2>
          <p className="text-neutral-300 mt-6 text-base md:text-lg max-w-xl">Nos responsables de secteur (« majors ») contrôlent régulièrement chaque site avec une grille objective, sur place et avec photos. Vous recevez un rapport de conformité et un plan d'actions correctives : la qualité se suit dans le temps, chiffres à l'appui.</p>
          <div className="flex flex-wrap gap-6 mt-8">
            {[["6", "zones contrôlées"], ["1–5", "note par zone"], ["100 %", "des contrôles sur site"]].map(([v, l]) => (
              <div key={l}><p className="font-heading font-extrabold text-3xl text-brand">{v}</p><p className="text-xs text-neutral-400 uppercase tracking-wider">{l}</p></div>
            ))}
          </div>
          <a href="/qualite" className="inline-flex items-center gap-2 mt-8 text-sm font-semibold text-white border border-white/20 hover:border-brand hover:text-brand px-4 py-2.5 rounded-md transition-colors" data-testid="quality-read-more">Notre démarche qualité en détail <ArrowRight size={15} /></a>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {QUALITY_STEPS.map((s, i) => (
            <div key={s.title} className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm" style={{ animationDelay: `${i * 80}ms` }}>
              <span className="w-10 h-10 rounded-xl bg-brand/20 text-brand flex items-center justify-center mb-3"><s.icon size={18} /></span>
              <h3 className="font-semibold text-base md:text-lg">{s.title}</h3>
              <p className="text-sm text-neutral-400 mt-1.5">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default QualitySection;
